module.exports = "<p>\n  register works!\n</p>\n"